import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d2d0160"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dimension-input__wrap" }
const _hoisted_2 = ["aria-describedby", "disabled", "id", "inputmode", "name", "readonly", "min", "max"]
const _hoisted_3 = {
  key: 1,
  class: "dimension-input__spinner"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-spinner2" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import {defineModel, watch} from "vue";
import debounce from "lodash/debounce";
import { endsWithSeparator, stripNonNumeric } from "@/functions/numbers";
import InputLabel from "@/components/UI/InputLabel.vue";
import InputGroup from "@/components/UI/InputGroup.vue";

interface Props {
	label?: string;
	instructions?: string;
	unit?: string;
	name: string;
	id: string;
	invalid: boolean;
	inputmode?: "decimal" | "text" | "numeric" | "search" | "email" | "tel" | "url" | "none";
	hidden?: boolean;
	onBlur?: () => void;
	isLoading?: boolean;
	disabled?: boolean;
	readonly?: boolean;
	min?: number;
	max?: number;
	delay?: number;
	step?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DimensionInput',
  props: /*#__PURE__*/_mergeModels({
    label: {},
    instructions: {},
    unit: {},
    name: {},
    id: {},
    invalid: { type: Boolean },
    inputmode: { default: "decimal" },
    hidden: { type: Boolean },
    onBlur: {},
    isLoading: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    min: {},
    max: {},
    delay: { default: 200 },
    step: { default: 0.1 }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const model = _useModel(__props, "modelValue");

const props = __props;

const isNumerical = [ "decimal", "numeric" ].includes( props.inputmode );

// check if step is set to whole number (without decimal)
const isWholeNumber = (): boolean => {
	return props.step ? props.step - Math.floor(props.step) === 0 : false;
};

watch( model, ( newValue: string|number ) => {
	if (!isNumerical) {
		updateModel(newValue);
		return;
	}
	if ( isNumerical && !isWholeNumber() && ( endsWithSeparator( newValue ) || newValue === "" ) ) {
		return;
	}
	const numericNewValue = stripNonNumeric( newValue );
	updateModel(numericNewValue);
} );

const describedby = (): string => {
	const ids = [];
	if(props.invalid) {
		ids.unshift(`${props.id}-validation-message`);
	}
	return ids.join(' ');
};

// Alternative way of debouncing inputs. See https://michael-mckenna.com/debouncing-input-change-event-wait-until-user-stops-typing
const updateModel = debounce((newValue: string|number) => {
	model.value = newValue;
}, props.delay);


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(InputGroup, { class: "dimension-input" }, {
    default: _withCtx(() => [
      (_ctx.label)
        ? (_openBlock(), _createBlock(InputLabel, {
            key: 0,
            class: "dimension-input__label",
            for: props.id,
            instructions: _ctx.instructions
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.label), 1)
            ]),
            _: 1
          }, 8, ["for", "instructions"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          ref: "input",
          class: _normalizeClass({ 'dimension-input__field': true, 'dimension-input__field--invalid': props.invalid }),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
          "aria-describedby": describedby(),
          disabled: _ctx.disabled,
          id: props.id,
          inputmode: props.inputmode,
          name: props.name,
          readonly: _ctx.readonly,
          type: "text",
          min: props.min ?? null,
          max: props.max ?? null,
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
        }, null, 42, _hoisted_2), [
          [_vModelText, model.value]
        ]),
        (props.unit && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass({ 'dimension-input__unit': true, 'dimension-input__unit--invalid': props.invalid })
            }, _toDisplayString(props.unit), 3))
          : _createCommentVNode("", true),
        (_ctx.isLoading === true)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 512)), [
    [_vShow, !props.hidden]
  ])
}
}

})